// extracted by mini-css-extract-plugin
module.exports = {"popover":"PopoverSharedStyle_popover__166sr","active":"PopoverSharedStyle_active__25iul","backdrop":"PopoverSharedStyle_backdrop__3CW41"};